import { render, staticRenderFns } from "./ShopeeCancelCensusDialog.vue?vue&type=template&id=089055a4&"
import script from "./ShopeeCancelCensusDialog.vue?vue&type=script&lang=js&"
export * from "./ShopeeCancelCensusDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShopeeCancelCensusDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports